<!-- BEGIN: Topbar -->
<div id="kt_header_topbar" class="kt-topbar kt-stack kt-stack--ver kt-stack--general d-flex flex-column">
  <nav class="kt-stack__item kt-topbar__nav-wrapper d-flex justify-content-center" [attr.aria-label]="l('TopMenu')">
    <ul class="kt-topbar__nav kt-nav kt-nav--inline"
      aria-label="TopMenu"
      role="menubar">
      <li class="kt-nav__item kt-topbar__user-profile kt-topbar__user-profile--img kt-dropdown kt-dropdown--medium kt-dropdown--arrow kt-dropdown--header-bg-fill kt-dropdown--align-right kt-dropdown--mobile-full-width kt-dropdown--skin-light" kt-dropdown-toggle="click">
        <a href="#" class="kt-nav__link kt-dropdown__toggle">
          <span class="kt-topbar__userpic">
            @if (profilePicture) {
              <img alt="" class="header-profile-picture kt--img-rounded kt--marginless kt--img-centered" [src]="profilePicture" />
            }
          </span>
          <span class="kt-topbar__username">
            @if (isImpersonatedLogin) {
              <i class="fa fa-reply kt--font-danger"></i>
            }
            @if (isMultiTenancyEnabled) {
              <span class="tenancy-name">{{tenancyName}}\</span>
              }{{userName}}
            </span>
          </a>
          <div class="kt-dropdown__wrapper">
            <span class="kt-dropdown__arrow kt-dropdown__arrow--right kt-dropdown__arrow--adjust"></span>
            <div class="kt-dropdown__inner">
              <div class="kt-dropdown__header kt--align-center" [ngStyle]="{ 'background': 'url(' + appRootUrl() + 'assets/metronic/assets/demo/' + currentTheme.baseSettings.theme + '/media/img/misc/user_profile_bg.jpg)', 'background-size': 'cover'}">
                <div class="kt-card-user kt-card-user--skin-dark">
                  <div class="kt-card-user__pic">
                    <img alt="" class="header-profile-picture kt--img-rounded kt--marginless kt--img-centered" [src]="profilePicture" />
                  </div>
                  <div class="kt-card-user__details">
                    <span class="kt-card-user__name kt--font-weight-500">
                      {{shownLoginName}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="kt-dropdown__body">
                <nav class="kt-dropdown__content" [attr.aria-label]="l('UserAccount')">
                  <ul class="kt-nav kt-nav--skin-light"
                    [attr.aria-label]="l('UserAccount')"
                    role="menu">
                    @if (isImpersonatedLogin) {
                      <li class="kt-nav__item">
                        <a href="javascript:;" class="kt-nav__link" (click)="backToMyAccount()"
                          role="menuitem"
                          aria-haspopup="true"
                          aria-expanded="false"
                          tabindex="-1">
                          <i class="kt-nav__link-icon fa fa-reply kt--font-danger"></i>
                          <span class="kt-nav__link-title">
                            <span class="kt-nav__link-wrap">
                              <span id="UserProfileBackToMyAccountButton" class="kt-nav__link-text">
                                {{"BackToMyAccount" | localize}}
                              </span>
                            </span>
                          </span>
                        </a>
                      </li>
                    }
                    @if (isImpersonatedLogin) {
                      <li class="kt-nav__separator kt-nav__separator--fit"></li>
                    }
                  <li class="kt-nav__separator kt-nav__separator--fit"></li>
                <li class="kt-nav__item">
                  <a href="javascript:;" class="kt-nav__link" (click)="showLoginAttempts()"
                    role="menuitem"
                    aria-haspopup="true"
                    aria-expanded="false"
                    tabindex="-1">
                    <i class="kt-nav__link-icon flaticon-list"></i>
                    <span class="kt-nav__link-title">
                      <span class="kt-nav__link-wrap">
                        <span id="ShowLoginAttemptsLink" class="kt-nav__link-text">
                          {{"LoginAttempts" | localize}}
                        </span>
                      </span>
                    </span>
                  </a>
                </li>
                <li class="kt-nav__item">
                  <a href="javascript:;" class="kt-nav__link" (click)="changeProfilePicture()"
                    role="menuitem"
                    aria-haspopup="true"
                    aria-expanded="false"
                    tabindex="-1">
                    <i class="kt-nav__link-icon flaticon-profile-1"></i>
                    <span class="kt-nav__link-title">
                      <span class="kt-nav__link-wrap">
                        <span id="UserProfileChangePictureLink" class="kt-nav__link-text">
                          {{"ChangeProfilePicture" | localize}}
                        </span>
                      </span>
                    </span>
                  </a>
                </li>
          <li class="kt-nav__separator kt-nav__separator--fit"></li>
          <li class="kt-nav__item">
            <a href="javascript:;" (click)="logout()" class="btn kt-btn--pill btn-secondary kt-btn kt-btn--custom kt-btn--label-brand kt-btn--bolder"
              role="menuitem"
              aria-haspopup="true"
              aria-expanded="false"
            tabindex="-1">{{"Logout" | localize}}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
</li>
</ul>
</nav>
</div>
<!-- END: Topbar -->
